// extracted by mini-css-extract-plugin
export default {"arrowContainer":"ArrowIndicator_arrowContainer__fz5Gh"};